import 'regenerator-runtime/runtime';
import { call, put } from 'redux-saga/effects';

import API, { methods } from '../../canvas-api';
import { handleGenericError } from '../../common';
import { actions } from '../../../reducers/slicer/slicer';

export default function* deleteProjectThumbnail(action) {
  try {
    const { projectId } = action.payload;

    const response = yield call(API, {
      method: methods.DELETE,
      path: `projects/${projectId}/thumbnail`,
    });
    if (response === null) return;

    yield put(
      actions.deleteProjectThumbnailSuccess(projectId, response.timestamp)
    );
  } catch (e) {
    yield call(handleGenericError, action, e);
  }
}
